import LocalizedStrings from 'localized-strings';

export const locales = new LocalizedStrings({
  en: {
    error: 'An error occurred. Please try again.',
    no: 'No',
    sidebar: {
      basicVatExemption: {
        bullets: {
          0: '**€36,800** for craft and liberal activity types',
          1: '**€91,900** for commercial or accomodation activity types',
        },
        info: "VAT exemption allows you not to declare, invoice or pay any VAT. In short, you don't owe any VAT for your activity. You don't invoice it to your clients, and you don't deduct it from your purchases. This exemption is accessible by any microenterprise of which the annual turnover is below:",
        question: 'What is VAT exemption?',
      },
      liableAsMicro: {
        info: 'This exemption applies automatically when you create your microenterprise, unless it was explicitly asked in the creation form. This exemption remains valid as long as the turnover VAT thresholds are respected (different from the microenterprise turnover thresholds).',
        question: 'How to know if I must pay VAT as a microenterprise?',
      },
      title: 'Learn more…',
    },
    title: 'You are liable for VAT',
    yes: 'Yes',
  },
  fr: {
    error: 'Une erreur est survenue. Veuillez réessayer.',
    no: 'Non',
    sidebar: {
      basicVatExemption: {
        bullets: {
          0: '**36 800 €** pour les activités de prestations de services artisanales et libérales',
          1: '**91 900 €** pour les activités commerciales et d’hébergement',
        },
        info: 'La franchise en base de TVA vous permet de ne pas avoir à déclarer, facturer et payer de TVA. En clair, vous n’êtes pas redevable de la TVA au titre de votre activité. Vous ne la facturez pas à vos clients et vous ne pouvez pas non plus la déduire de vos achats. Ce dispositif est accessible à toutes les auto-entreprises dont le chiffre d’affaires annuel est inférieur à :',
        question: 'Qu’est-ce que la franchise en base de TVA ?',
      },
      liableAsMicro: {
        info: 'Lorsque vous créez votre micro-entreprise, vous bénéficiez automatiquement de cette exonération, à moins d’avoir explicitement demandé le contraire sur votre formulaire de début d’activité. Cette exonération reste ensuite valable tant que vous respectez les plafonds de chiffre d’affaires pour la TVA (qui sont différents des plafonds de la micro-entreprise).',
        question:
          'Comment savoir si je suis redevable de la TVA en micro-entreprise ?',
      },
      title: 'En savoir plus…',
    },
    title: 'Vous êtes redevable de la TVA',
    yes: 'Oui',
  },
} as const);
